module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.bfd87a62.jpg";